import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { AdminService } from '@appShared/services/admin.service';
import {
  ShareholderApiActions,
  ShareholderPageActions
} from '@appState/actions/shareholder';

@Injectable()
export class ShareholderEffects {
  constructor(
    private _actions$: Actions,
    private _adminService: AdminService
  ) {}

  loadShareholders$ = createEffect(() => {
    return this._actions$.pipe(
      ofType(ShareholderPageActions.loadShareholders),
      switchMap(action =>
        this._adminService
          .getShareholders(action.includeRepurchaseOptionExecuted)
          .pipe(
            map(shareholders =>
              ShareholderApiActions.loadShareholdersSuccess({ shareholders })
            ),
            catchError(error =>
              of(ShareholderApiActions.loadShareholdersFailure({ error }))
            )
          )
      )
    );
  });
}
